import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=fbd36cfe&scoped=true&"
import script from "./Calculation.vue?vue&type=script&lang=ts&"
export * from "./Calculation.vue?vue&type=script&lang=ts&"
import style0 from "./Calculation.vue?vue&type=style&index=0&id=fbd36cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd36cfe",
  null
  
)

export default component.exports